import React from 'react';
import { Button } from '../ui';
import type { CreditsByStudent } from '../../services/makeupCredit';

interface StudentCreditsSummaryProps {
  byStudent: CreditsByStudent[];
  onUseCredit: (studentId: string, creditId: string) => void;
}


/** Simple per-student credit message with Use Credit CTA (replaces stats box) */
export const StudentCreditsSummary: React.FC<StudentCreditsSummaryProps> = ({
  byStudent,
  onUseCredit,
}) => {
  if (byStudent.length === 0) return null;

  return (
    <div className="space-y-3">
      {byStudent.map((s) => (
        <div
          key={s.studentId}
          className="flex items-center justify-between rounded-lg border border-purple-200 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/20 p-4"
        >
          <p className="text-gray-900 dark:text-white font-medium">
            You have {s.availableCount} make-up credit{s.availableCount !== 1 ? 's' : ''} for{' '}
            <span className="font-semibold">{s.studentName}</span>
            {s.scope === 'term' && (
              <span className="ml-2 text-xs text-purple-600 dark:text-purple-400">(term re-enrolment)</span>
            )}
          </p>
          {s.creditId && (
            <Button onClick={() => onUseCredit(s.studentId, s.creditId!)}>
              {s.scope === 'term' ? 'Use term credit' : 'Use Credit'}
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default StudentCreditsSummary;
